<div class="justify-content-center align-items-center row">
  <div *ngIf="showToast" class="alert" [ngClass]="alertClass" role="alert">
 {{ errorResponse.code }} - {{ errorResponse.message }}
</div>

</div>
